// Új verzió felismerése (2026-09-24, élő hiba).
//
// A deploy után egy korábban megnyitott lap a RÉGI bundle-lel fut tovább. A régi kód a régi
// step-up úton kért passkeyt, a backend pedig — helyesen — elutasította az utalást, egy
// olyan hibaüzenettel, amiből nem derült ki, hogy csak frissíteni kellene.
//
// A mérce: a betöltött `main.*.js` neve vs. a szerver `asset-manifest.json`-jában álló
// `main.js`. A manifest `Cache-Control: no-cache`-sel jön (mérve), a fetch ráadásul
// `no-store`. Fejlesztői szerveren nincs hash-elt `main.*.js` — ott soha nem jelez.

export const VERSION_STALE_EVENT = 'puo:version-stale';

function loadedBundle() {
  const el = document.querySelector('script[src*="/static/js/main."]');
  const src = el?.getAttribute('src') || '';
  const m = src.match(/\/static\/js\/main\.[a-z0-9]+\.js/i);
  return m ? m[0] : null;
}

/** true = a szerveren újabb verzió van; false = azonos, vagy nem eldönthető (a
 *  hálózati hiba soha ne blokkoljon — a backend-kapuk attól még védenek). */
export async function isStale() {
  const mine = loadedBundle();
  if (!mine) return false;
  try {
    const res = await fetch('/asset-manifest.json', { cache: 'no-store' });
    if (!res.ok) return false;
    const latest = (await res.json())?.files?.['main.js'];
    const stale = !!latest && latest !== mine;
    if (stale) window.dispatchEvent(new Event(VERSION_STALE_EVENT));
    return stale;
  } catch {
    return false;
  }
}
